import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr"
import { ErrorLogService } from "@/services/";

var connection;
export class AlertService {

    public static setUpAlertHub() {
      connection = new HubConnectionBuilder()
      .withUrl(AlertService.getApiUrl())
      .configureLogging(LogLevel.Information)
      .build();

      this.startAlertHub();
    }

    public static getApiUrl(){
      var result = window.appGlobals.API_URL + "alert-hub";
      return result;
    }

    public static async startAlertHub(){
       // Wait for connection to start or error before proceeding
      var errorLog = "";
      var successful = false;
      const maxAttempts = 5;
      var attempt = 0;
      do{
        try{     
          await connection.start();
          successful = true;
        }
        catch(err){
          attempt++;
          errorLog = "Attempted " + attempt + " of " + maxAttempts + " tries to connect to SignalR service failed: "  + err + "\n";
          await new Promise(resolve => setTimeout(resolve, 30000));
        }
      }
        while(successful === false && attempt < maxAttempts  && connection.state != 1); 
        if (!successful){
          ErrorLogService.LogException(Error(errorLog));
        }
    }

    public static getAlertHub(){
        return connection;
    }   

  }